export const config= {
    host:"http://jsonplaceholder.typicode.com"
}